import React, { useState, useEffect } from "react";
import { FormLabel } from "react-bootstrap";

import FenceIcon from "../../images/fence-icon.svg";

const FenceIcn = (props) => {
  const { icon } = props;
  return (
    <>
      <div className="fence-icn-wrap">
        {icon ? (
          <img src={require("..//../images/" + icon)} />
        ) : (
          <img src={FenceIcon} />
        )}
      </div>

      {/*<div className="fence-icn-count"><span>12</span></div>*/}
    </>
  );
};
export default FenceIcn;
